import { Calendar, Card, Leaf, Payment, Typography, User } from '@sonnen/web-ui';
import { createElement } from 'react';
import HouseWithCellsAndCar700 from '../../../assets/images/HouseWithCellsAndCar700.webp';
import HouseWithCellsAndCar1400 from '../../../assets/images/HouseWithCellsAndCar1400.webp';
import CroppedImage from '../../../components/CroppedImage/CroppedImage';
import { useTranslation } from '../../../i18n/i18n';
import styles from './EnergyFixBenefits.module.css';

const EnergyFixBenefits = () => {
  const { t } = useTranslation();

  const benefits = [
    { icon: User, text: t('tariffOverview.energyFix.cardBenefits.financialStability') },
    { icon: Payment, text: t('tariffOverview.energyFix.cardBenefits.fixedPrice') },
    { icon: Leaf, text: t('tariffOverview.energyFix.cardBenefits.greenEnergy') },
    { icon: Calendar, text: t('tariffOverview.energyFix.cardBenefits.priceGuarantee') },
  ];

  return (
    <>
      <div className={styles.headerWithImage}>
        <div className={styles.headerText}>
          <Typography.H2 variant="on-colour">
            {t('tariffOverview.energyFix.cardBenefits.title')}
          </Typography.H2>
        </div>
        <div className={styles.image}>
          <CroppedImage
            height={224}
            src={HouseWithCellsAndCar700}
            srcSet={`${HouseWithCellsAndCar700} 1x, ${HouseWithCellsAndCar1400} 2x`}
            dataTestId="benefits-card-img"
            alt={t('tariffOverview.energyFix.cardBenefits.imageAlt')}
          />
        </div>
      </div>

      <Card withBottomSpace={false} paddingSize="md">
        <ul className={styles.benefitsList}>
          {benefits.map((benefit, index) => (
            <li key={index} className={styles.benefitItem}>
              {createElement(benefit.icon)}
              <Typography.Body1>{benefit.text}</Typography.Body1>
            </li>
          ))}
        </ul>
      </Card>
    </>
  );
};

export default EnergyFixBenefits;
